import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { EventFormat, T2DomainEnum } from 'types/event.types';

export interface DuplicateEventV2InputType {
  eventId: number;
  duplicateType: string;
  timezoneCode?: string;
  datetimeScheduled?: string;
  datetimeEnd?: string;
  allDay?: boolean;
  connectSlackChannel?: boolean | null;
  eventFormat?: EventFormat;
  virtualLink?: string;
  inPersonLocation?: string;
  zoomMeetingId?: number | null;
  googleMeetingId?: number | null;
  t2DomainArray?: T2DomainEnum[] | null;
}

export interface DuplicateEventResult {
  duplicateEventV2: {
    ok: boolean;
    event: {
      id: number;
    };
  };
}

const DuplicateEventMutation = gql`
  mutation duplicateEventV2($input: DuplicateEventV2InputType!) {
    duplicateEventV2(input: $input) {
      ok
      event {
        id
      }
    }
  }
`;

export const duplicateEvent = (input: DuplicateEventV2InputType): Promise<DuplicateEventResult> => {
  return gqlClient.request<DuplicateEventResult>(DuplicateEventMutation, { input });
};
